// api/discordUpdate.ts

import { getMarketName, getSelectionName } from '@azuro-org/dictionaries'
import { updateDiscordChannelApi } from 'src/utils/api'
import { getBetTransactionData } from 'src/utils/getBetTransactionData'

const updateDiscordChannel = async (
  betDetails: AzuroSDK.BetslipItem[],
  betAmount: string,
  totalOdds: number,
  transactionHash: string,
  chainId: number,
  publicClient: any,
  odds?: Record<string, number>,
  isSingleBet?: boolean,
  isBatch?: boolean,
  batchAmounts?: Record<string, string>,
  isLive?: boolean
  // walletAddress: `0x${string}`
) => {
  const { tokenId } = await getBetTransactionData(transactionHash, publicClient)

  const updatedItems = betDetails.map((item: any) => ({
    ...item,
    tokenId,
    chainId,
    transactionHash,
    isSingleBet,
    betAmount,
    totalOdds,
    odds,
    batchAmounts,
    live: isLive,
    market: getMarketName({ outcomeId: item.outcomeId }),
    isBatch,
    selection: getSelectionName({
      outcomeId: item.outcomeId,
      withPoint: true,
    }),
  }))

  try {
    const response = await updateDiscordChannelApi({
      items: updatedItems,
    })
    return response
  } catch (error) {
    const err = error as Error
    console.error('Error updating Discord channel', err)
  }
}

export default updateDiscordChannel
